module.exports = __webpack_public_path__ + "assets/DropPerp.080c45ce120320218bfbc2263aff2254.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/DropPerp.gmt
// module id = 936
// module chunks = 0